import { useMutation } from '@tanstack/react-query';

import type { Persona } from '../../../domain/persona';
import { useUseCases } from '../../../UseCaseProvider';

export const useDeletePersonaMutation = (onSuccess: () => void) => {
  const { deletePersona } = useUseCases();
  return useMutation({
    mutationKey: ['delete-persona'],
    mutationFn: (persona: Persona) => deletePersona(persona),
    onSuccess,
  });
};
